// extracted by mini-css-extract-plugin
module.exports = {"appInfoWarp":"AppInfo_appInfoWarp__qg6vm"};